module.exports = __webpack_public_path__ + "img/logo-operasi.7b143f71.png";